import type { SxProps, Theme } from "@mui/material";

export const sourceCard = (active: boolean): SxProps<Theme> => ({
  borderRadius: 2,
  border: `2px solid ${active ? "#026937" : "#ededed"}`,
  boxShadow: active
    ? "0px 6px 20px rgba(0,0,0,0.1)"
    : "0px 4px 16px rgba(0,0,0,0.05)",
  transition: "transform 0.2s",
  "&:hover": {
    transform: "translateY(-1px)",
    boxShadow: "0px 6px 20px rgba(0,0,0,0.1)",
  },
  backgroundColor: active ? "primary.main" : "white",
});
